import React, { useContext, useEffect } from 'react';

import { DiffSet, DiffSetProps } from 'src/components/diff-set/diff-set';

import { DiffAnalyticsContext } from './diff-analytics-context';

/* eslint @typescript-eslint/ban-types: "warn" */
const DiffSetWithPageLoad: React.FC<DiffSetProps> = props => {
  const { onPageLoad } = useContext(DiffAnalyticsContext);

  useEffect(() => {
    onPageLoad();
    // Custom page load metric is intended to be published on the initial mount of the component
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <DiffSet {...props} />;
};

export default DiffSetWithPageLoad;
